import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[loadComponent]',
})
export class DynamicComponentDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}